import React, { useEffect } from "react";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { useTranslation } from "react-i18next";

import { DataStructure } from "@/components/StaticTable";

interface ChampsSelectProps<T> {
  dataStructure: DataStructure<T>[];
  selectedcolumn: DataStructure<T>;
  setSelectedFiltreKey: React.Dispatch<React.SetStateAction<string | null>>;
  selectedFiltreKey: string | null;
}

export function ChampsSelect<T>({
  dataStructure,
  selectedcolumn,
  setSelectedFiltreKey,
  selectedFiltreKey,
}: ChampsSelectProps<T>) {
  const { t } = useTranslation();

  useEffect(() => {
    if (getFiltresKeys().length === 1)
      setSelectedFiltreKey(getFiltresKeys()[0]);
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedcolumn]);

  const handleChange = (event: any) =>
    setSelectedFiltreKey(event?.target?.value);

  const getFiltresKeys = (): string[] => {
    if (!selectedcolumn || !selectedcolumn.filter) return [];
    if (Array.isArray(selectedcolumn.filter)) {
      // @ts-ignore
      return selectedcolumn?.filter!.map((filtre) => filtre.key);
    } else {
      // @ts-ignore
      return [selectedcolumn?.filter!.key];
    }
  };

  let items = getFiltresKeys();

  const getFiltreLabel = (filtreStr: string) => {
    let listFiltres = dataStructure
      .map((ds) => ds.filter)
      .filter(Boolean)
      .flat();

    let filtre = listFiltres.find((filtre) => {
      return filtre?.key === filtreStr;
    });

    let ds = dataStructure.find((ds) => {
      if (!ds.filter) return false;
      if (Array.isArray(ds.filter)) {
        return ds.filter.some((f) => f.key === filtre?.key);
      }
      return ds.filter.key === filtre?.key;
    });

    return filtre ? ("label" in filtre ? filtre.label : ds?.label) : filtreStr;
  };

  return (
    <FormControl variant="filled" fullWidth>
      <InputLabel>{t("common.dmri.filter.field")}</InputLabel>
      <Select
        onChange={handleChange}
        value={selectedFiltreKey}
        disabled={items.length < 2}
      >
        {items.map((item, index) => {
          return (
            <MenuItem key={index} value={item}>
              {getFiltreLabel(item)}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}

export default ChampsSelect;
